import * as XLSX from 'xlsx';
import {
  buildTenderOpeningDownloadFilename,
  displayValue,
} from './tenderOpeningHelpers';
import { mapHpsParcelIncotermRows } from '../components/Detail/HpsParcel/nonLpg/utils';
import {
  cargoNeedsFreight,
  isFobIncoterm,
} from '../../../shared/offer-domain/delivery/freight';

export const PARCEL_FREIGHT_EXPORT_COLUMNS = [
  { header: 'LOADING', key: 'loadingPort' },
  { header: 'CARGO', key: 'cargo' },
  { header: 'VOLUME', key: 'volume' },
  { header: 'ALD/ADD', key: 'aldAdd' },
  { header: 'DISCHARGED 1', key: 'discharged1' },
  { header: 'DISCHARGED 2', key: 'discharged2' },
  { header: 'DISCHARGED 3', key: 'discharged3' },
  { header: 'FREIGHT LUMPSUM (USD)', key: 'freightLumpsum' },
  { header: 'LAYTIME (HOURS)', key: 'laytime' },
  { header: 'DEMURRAGE PDPR (PER DAY PRO RATE)', key: 'demurrage' },
  { header: 'R2', key: 'r2' },
];

const getDischargePort = (rows, portKey) => {
  for (const row of rows) {
    const value = row?.[portKey];
    if (value && value !== '-') {
      return displayValue(value);
    }
  }
  return '-';
};

const formatFobLoadingPort = row => {
  const parts = [row.incoterm, row.route, row.loadingPort]
    .map(value => {
      if (
        value === null ||
        value === undefined ||
        value === '' ||
        value === '-'
      ) {
        return '';
      }
      return String(value).trim();
    })
    .filter(Boolean);

  return parts.length ? parts.join(' ') : '-';
};

export const buildParcelFreightExportRows = (parcels = []) => {
  if (!parcels?.length) return [];

  return parcels.flatMap(parcel => {
    const cargoLabel = parcel.deliveryUnit || '-';
    const allIncotermRows = mapHpsParcelIncotermRows(parcel);
    // FOB-only cargo (no CFR/DAP/CIF) needs no freight request
    if (!cargoNeedsFreight(allIncotermRows)) {
      return [];
    }

    const fobRows = allIncotermRows.filter(isFobIncoterm);

    return fobRows.map(row => {
      const deliveryBasis = displayValue(row.deliveryBasis);

      return {
        cargo: cargoLabel,
        loadingPort: formatFobLoadingPort(row),
        volume: deliveryBasis === '-' ? '-' : `${deliveryBasis} MB`,
        aldAdd: displayValue(row.aldAdd1),
        discharged1: getDischargePort(allIncotermRows, 'port1'),
        discharged2: getDischargePort(allIncotermRows, 'port2'),
        discharged3: getDischargePort(allIncotermRows, 'port3'),
        freightLumpsum: 'Requested',
        laytime: 'Requested',
        demurrage: 'Requested',
        r2: 'Requested',
      };
    });
  });
};

export const downloadParcelFreightExcel = (
  rows,
  { procurementNumber, submittedDate } = {}
) => {
  const filename = buildTenderOpeningDownloadFilename({
    procurementNumber,
    title: 'Parcel_Request_Freight_Availability',
    submittedDate,
    extension: 'xlsx',
  });
  const headers = PARCEL_FREIGHT_EXPORT_COLUMNS.map(column => column.header);
  const data = rows.map(row =>
    PARCEL_FREIGHT_EXPORT_COLUMNS.map(column => row[column.key])
  );

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Parcel Freight');
  XLSX.writeFile(workbook, filename);
};
